import { Form } from 'antd';
import { useContext, useMemo } from 'react';

import { SCard } from 'app/components/StaycationUI';
import { FeaturesComponent } from 'app/components/commons/Features/Features';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { useRoomFeatures } from 'app/hooks/data/rooms/useGetRoomFeatures';
import type { RoomFeature } from 'app/typings';
import { getBlockedBathroomFeatures } from 'app/utils/room';

export const Features = () => {
  const { data: roomFeatures } = useRoomFeatures();
  const { mode } = useContext(ViewEditModeContext);

  const featuresByCategory = useMemo<Record<string, RoomFeature[]>>(() => {
    return (
      roomFeatures?.reduce((acc, feature) => {
        if (!acc[feature.category]) {
          acc[feature.category] = [];
        }

        acc[feature.category].push(feature);

        return acc;
      }, {} as Record<string, RoomFeature[]>) ?? {}
    );
  }, [roomFeatures]);

  return (
    <SCard title="Features">
      <Form.Item name="featureIds">
        <FeaturesComponent
          featuresByCategory={featuresByCategory}
          getDisabledFeatureIds={getBlockedBathroomFeatures}
          mode={mode}
        />
      </Form.Item>
    </SCard>
  );
};
